module.exports = __webpack_public_path__ + "img/coupon-logo@2x.c807ff92.png";